import React from 'react';
import { compose } from 'recompose';
import { Formik } from 'formik';
import { connect } from 'react-redux';
import * as Yup from 'yup';
import EditStudentModalForm from './EditStudentModalForm';

const StudentSchema = Yup.object().shape({
  firstname: Yup.string().required('errorRequired'),
  // lastname: Yup.string().required('errorRequired').ensure(),
  registration: Yup.string()
    .required('errorRequired')
    .matches(/^[a-zA-Z0-9]+$/, 'errorAlphanumeric'),
  call: Yup.string().required('errorRequired'),
  email: Yup.string().email('errorInvalidEmail').required('errorRequired'),
  newIdEsCourse: Yup.string().required('Required'),
  currentIdESCourse: Yup.string(),
});

function getInitialValues(student, idESCourse) {
  if (!student) return {};
  return {
    ...student,
    newIdEsCourse: idESCourse,
    currentIdESCourse: idESCourse,
  };
}

const EditStudentModal = (props) => {
  const initialValues = getInitialValues(props.student, props.groupSelected);
  const validationSchema = props.readOnly ? undefined : StudentSchema;

  return (
    <Formik
      validationSchema={validationSchema}
      initialValues={{ ...initialValues }}
      enableReinitialize
      render={(formProps) => <EditStudentModalForm {...props} {...formProps} error={props.error} />}
      groups={props.groups}
    />
  );
};

EditStudentModal.propTypes = {};

const mapStateToProps = ({ editClass }) => ({
  error: editClass.errors.edit,
  student: editClass.student,
});

export default connect(mapStateToProps)(EditStudentModal);
